module.exports = __webpack_public_path__ + "img/gift.e8755d63.svg";